import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminOnboardingView = () => import('@/views/admin/OnboardingView.vue');
export const NAME_ADMIN_ONBOARDING = 'AdminOnboarding';
export const PATH_ADMIN_ONBOARDING = 'onboarding';

export const route: DiscoveredRouteModule = {
  id: 'admin.onboarding',
  scope: 'admin',
  moduleKey: 'onboarding',
  name: NAME_ADMIN_ONBOARDING,
  path: PATH_ADMIN_ONBOARDING,
  component: AdminOnboardingView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_user_fields', 'project_settings', 'project_channels', 'project_events', 'project_mail', 'project_subscriptions'] },
};
